<template>
  <ejs-dialog
    ref="formDialog"
    id="roles-form"
    class="dialog-papirus"
    target="#dialogRoles"
    :isModal="true"
    :visible="showing"
    :header="header"
    :width="width"
    :showCloseIcon="true"
    :close="onDialogClose"
    :beforeOpen="beforeDialogOpen"
    :open="onDialogOpen"
    z-index="1003"
  >
    <div class="col-lg-12 e-input-section">
      <div class="content-wrapper">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-10 col-md-12">
            <label class="e-text">Nombre Rol</label>
            <input
              id="name"
              class="e-input"
              :class="{ 'e-warning': hasError('name') }"
              type="text"
              required
              v-model="m_data.name"
              :readonly="isFormReadOnly"
              @input="validateField('name')"
              @blur="validateField('name')"
              placeholder="Nombre Rol"
            />
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('name') }"
              v-text="m_errors.name"
            >
            </span>
          </div>
          <div
            class="col-xs-12 col-sm-12 col-lg-2 col-md-12 control-section switch-control classEspecial"
            v-show="showId"
          >
            <div>
              <ejs-switch
                cssClass="align-middle"
                id="active"
                v-model="m_data.active"
                :checked="m_data.active"
                :disabled="isFormReadOnly || !canDelete"
              ></ejs-switch>
              <label for="active" class="e-text align-middle switch-label">{{
                m_data.active ? "Activo" : "Inactivo"
              }}</label>
            </div>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
            <span class="e-icons icon-lock inline-command"></span>
            <h6 style="display: inline">Accesos</h6>
          </div>
          <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
            <ejs-treeview
              id="treeview"
              ref="treeObj"
              :fields="fields"
              :disabled="isFormReadOnly"
              :showCheckBox="true"
            ></ejs-treeview>
          </div>
        </div>
        <div class="row pull-right">
          <div class="col-xs-12 col-sm-12">
            <div class="e-btn-group">
              <ejs-button
                @click.native="validateForm"
                :isPrimary="true"
                iconCss="e-icons icon-save inline-command"
                cssClass="e-flat e-noback"
                v-if="showSaveButton"
                >Grabar</ejs-button
              >
              <ejs-button
                @click.native="validateDelete"
                :isDanger="true"
                iconCss="e-icons icon-trash inline-command"
                cssClass="e-flat e-danger e-noback"
                v-if="showDeleteButton"
                >Desactivar</ejs-button
              >
              <ejs-button
                @click.native="close()"
                iconCss="e-icons icon-cancel inline-command"
                cssClass="e-flat e-noback"
                >Cancelar</ejs-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </ejs-dialog>
</template>

<script>
import Vue from "vue";
/*import { object, string, number, yup, when } from "yup";*/

import { FormActionEnum } from "../../services/enums.js";
import PermissionMixin from "../../mixins/PermissionMixin";
import ToastMixin from "../../mixins/ToastMixin";

/* Plugins de Syncfusion */
import { TreeViewPlugin } from "@syncfusion/ej2-vue-navigations";
import { CheckBoxPlugin } from "@syncfusion/ej2-vue-buttons";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { SwitchPlugin } from "@syncfusion/ej2-vue-buttons";
import { NumericTextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";

/* Utilidades Syncfusion */
import { DialogUtility } from "@syncfusion/ej2-popups";
import {
  createSpinner,
  showSpinner,
  hideSpinner
} from "@syncfusion/ej2-popups";

/* Validación con YUP*/

import * as Yup from "yup";
import { es } from "yup-locales";
import { setLocale } from "yup";
setLocale(es);

Vue.use(DialogPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(ButtonPlugin);
Vue.use(TreeViewPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);

export default Vue.extend({
  mixins: [PermissionMixin, ToastMixin],
  computed: {
    showId() {
      return this.formAction !== FormActionEnum.ADD;
    },
    showSaveButton() {
      return (
        this.formAction === FormActionEnum.ADD ||
        this.formAction === FormActionEnum.EDIT
      );
    },
    showDeleteButton() {
      return this.formAction == FormActionEnum.DELETE;
    },
    customClass() {
      return {
        "dialog-papirus": true,
        "dialog-edit":
          this.formAction == FormActionEnum.ADD ||
          this.formAction == FormActionEnum.EDIT,
        "dialog-view": this.formAction == FormActionEnum.VIEW,
        "dialog-delete": this.formAction == FormActionEnum.DELETE
      };
    },
    isFormReadOnly() {
      var ret = false;

      switch (this.formAction) {
        case FormActionEnum.ADD:
          break;
        case FormActionEnum.EDIT:
          break;
        case FormActionEnum.VIEW:
          ret = true;
          break;
        case FormActionEnum.DELETE:
          ret = true;
          break;
      }
      return ret;
    },
    header() {
      if (this.formAction === FormActionEnum.ADD) {
        return "Nuevo Rol";
      }
      if (this.formAction === FormActionEnum.VIEW) {
        return "Consultar Rol";
      }
      if (this.formAction === FormActionEnum.EDIT) {
        return "Modificar Rol";
      }
      if (this.formAction === FormActionEnum.DELETE) {
        return "Deshabilitar Rol";
      }
      return "";
    },
    canDelete() {
      if (!this.hasPermission("CanDelete")) {
        return false;
      }
      return true;
    }
  },
  data() {
    return {
      /* Datos del Componente*/
      isValid: false,
      isMounted: false,
      validationSchema: {},
      m_errors: {},
      m_data: {},
      fields: {},
      m_treeview: [],
      /* Datos del Dialogo de Syncfusion*/
      isModal: true,
      /*isOpen: false,*/
      target: document.getElementById("dialog"),
      width: this.isMobile ? "500px" : "70%"
    };
  },
  created() {},
  mounted() {
    try {
      //crear el spinner de loading

      createSpinner({
        target: this.$refs.formDialog.$el
      });

      this.buildYupSchema();
      this.isMounted = true;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    beforeDialogOpen() {
      this.m_treeview = JSON.parse(JSON.stringify(this.formData.roleClaims));
      this.fields = {
        dataSource: this.m_treeview,
        id: "id",
        text: "claimsName",
        child: "childs",
        htmlAttribute: "attributes"
      };
      this.m_data = Object.assign({}, this.formData);
    },
    onDialogOpen() {
      this.m_errors = {};
    },
    onDialogClose() {
      this.clearErrors();
      this.$emit("formClosed");
    },
    close() {
      this.$emit("formClosed");
    },
    getAlertDialog(title, content) {
      let dialog = DialogUtility.alert({
        title: title,
        zindex: 1010,
        content: content,
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: "Zoom" }
      });
      return dialog;
    },
    showSpinner() {
      showSpinner(this.$refs.formDialog.$el);
    },
    hideSpinner() {
      hideSpinner(this.$refs.formDialog.$el);
    },
    clearErrors() {
      this.m_errors = {};
    },
    async saveData() {
      try {
        this.showSpinner();
        switch (this.formAction) {
          case FormActionEnum.VIEW:
            this.showToast(
              "No habilitado",
              "Modo consulta, nada para grabar!",
              2000
            );
            break;
          case FormActionEnum.ADD:
            this.m_data.applicationClaims = this.loadClaims();
            if (this.m_data.applicationClaims.length == 0) {
              this.showToast(
                "Invalido!",
                "Debe seleccionar almenos un acceso!",
                2000
              );
              break;
            }
            this.m_data.roleClaims = [];
            this.m_data.active = true;
            await this.$store.dispatch("roles/createRole", this.m_data);
            this.showToast("Confirmación", "Registro Creado!", 2000);
            break;
          case FormActionEnum.EDIT:
            this.m_data.applicationClaims = this.loadClaims();
            if (this.m_data.applicationClaims.length == 0) {
              this.showToast(
                "Invalido!",
                "Debe seleccionar almenos un acceso!",
                2000
              );
              break;
            }
            this.m_data.roleClaims = [];
            await this.$store.dispatch("roles/updateRole", {
              id: this.m_data.id,
              role: JSON.parse(JSON.stringify(this.m_data))
            });
            this.showToast("Confirmación", "Registro Actualizado", 2000);
            break;
        }
        await this.$store.dispatch("roles/getRoles");
        /* esperar medio segundo antes de cerrar */
        setTimeout(() => {
          this.hideSpinner();
          this.close();
        }, 500);
      } catch (error) {
        this.hideSpinner();
        this.showToast(
          "Error!",
          "Ocurrió un error al ejecutar la operación",
          2000
        );
      }
    },
    buildYupSchema() {
      /*Hack para esLint*/

      this.validationSchema = Yup.object().shape({
        isNew: Yup.boolean(),
        name: Yup.string().required().max(50).label("Rol")
      });
    },
    hasError(field) {
      return !!this.m_errors[field];
    },
    async validateField(field) {
      Vue.set(this.m_errors, field, "");

      if (this.isFormReadOnly) return;

      this.validationSchema.validateAt(field, this.m_data).catch((err) => {
        Vue.set(this.m_errors, err.path, err.message);
      });
    },
    async validateForm() {
      this.isValid = false;

      try {
        await this.validationSchema.validate(this.m_data, {
          abortEarly: false
        });

        this.m_errors = {};
        /*Grabar los datos*/
        await this.saveData();
      } catch (error) {
        error.inner.forEach((error) => {
          Vue.set(this.m_errors, error.path, error.message);
          //this.m_errors[error.path] = error.message;
        });
      }
    },
    loadClaims() {
      var data = this.$refs.treeObj.ej2Instances.checkedNodes;
      var salida = [{ applicationClaimsId: 0, applicationPermissionsRole: [] }];
      data.forEach((element) => {
        var arraydata = element.split("-");
        if (
          !salida.find((element) => element.applicationClaimsId == arraydata[0])
        ) {
          salida.push({
            applicationClaimsId: arraydata[0],
            applicationPermissionsRole: [
              {
                applicationPermissionId: "6" //Se agrega permiso CanList por defecto
              }
            ]
          });
        }

        if (arraydata.length > 1) {
          if (
            !salida.find(
              (element) => element.applicationClaimsId == arraydata[1]
            )
          ) {
            salida.push({
              applicationClaimsId: arraydata[1],
              applicationPermissionsRole: []
            });
          }
        }

        if (arraydata.length > 2) {
          salida
            .find((element) => element.applicationClaimsId == arraydata[1])
            .applicationPermissionsRole.push({
              applicationPermissionId: arraydata[2]
            });
        }
      });

      var retObject = salida.filter(function (obj) {
        return obj.applicationClaimsId > 0;
      });

      return retObject;
    }
  },

  props: {
    /** Whether the dialog is currently showing */
    showing: {
      type: Boolean,
      required: true,
      default: false
    },
    formAction: {
      type: Number,
      required: true,
      default: 0
    },
    isMobile: {
      type: Boolean,
      required: true,
      default: false
    },
    formData: {
      type: Object,
      required: false,
      default() {
        return { id: 0, name: "", active: 0, roleClaims: [] };
      }
    }
  }
});
</script>

<style scoped>
@import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../form-icons.css);

.classEspecial {
  align-self: center;
}

.dialog-papirus.e-dialog .e-dlg-header {
  color: #0078d6;
  font-size: 20px;
  font-weight: normal;
}

.content-wrapper div.row {
  padding: 5px 0px;
}

.switch-label {
  padding: 0px 0px 0px 20px;
  margin: auto;
  cursor: pointer;
}

.e-save.e-icons:before,
.e-save.e-icons:before {
  content: "\e609";
}

@media only screen and (max-width: 480px) {
  .content-wrapper {
    width: 92%;
  }
  .e-input-section .col-xs-6,
  .e-input-section .col-xs-4,
  .e-input-section .col-xs-12 {
    padding: 10px 5px;
    width: 100%;
  }
  .content-wrapper div.row {
    padding: 0px;
  }
}
</style>
